enum PackageFeeTypeEnum {
  PERCENT = 'PERCENT',
  FIXED = 'FIXED',
  ADVERTISER = 'ADVERTISER',
}

export default PackageFeeTypeEnum;
